import React, { useEffect, useState } from "react";
/** React Hooks */
import { useNavigate } from "react-router-dom";
/** Formik */
import { Form, Formik, FormikHelpers } from "formik";
import { RootState } from "store";
import { useSelector } from "react-redux";
import { closeInviteUserInBulkModalAction } from "store/modals/reducer.actions";
import { useDispatch } from "react-redux";
/** Utils */
import { getBrandName } from "utils/customBranding";
import { getAppCode } from "hooks/useCustomBranding/constants";
import { createPasswordModalValidationSchema } from "utils/validationSchemas";
/** Services */
import apiLibrary from "services/api";
import apiClient from "services/apiClient";
/** Libs */
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
/** Components */
import XCloseIcon from "assets/icons/HeroIcons/XCloseIcon";
import { Toasts } from "view/components/Toasts";
import Button from "view/components/Button";
import MultiSelect from "view/components/Multiselect";
import { usersStatusAction } from "store/filters";

const style: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  backgroundColor: "#ffff",
};

interface DeleteCommunityModalProps {}

export const InviteUserInBulk: React.FC<DeleteCommunityModalProps> = () => {
  const { inviteUserInBulkModal } = useSelector(
    (state: RootState) => state.modals
  );
  const [searchString, setSearchString] = useState("");
  const [appName, setAppName] = useState([
    {
      value: "",
      label: "",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeInviteUserInBulkModalAction());
  };
  const defaultAppName = {
    value: getAppCode().brandCode ?? "",
    label: getAppCode().brandName ?? "",
  };
  const initialValues = {
    password: "",
    forceToUpdatePassword: true,
    appName: defaultAppName,
  };
  const getBrandsData = async (searchString: string = "") => {
    try {
      const resultData = getBrandName("brands", searchString);
      const { data } = await apiClient.get(resultData.url);

      if (data?.data?.brands) {
        const { brands } = data.data; // Destructure brands from the data
        // const allApps = [...brands, { name: "ISN", appId: "isn" }];
        const appList = brands.map((item: any) => ({
          value: item.appId,
          label: item.name,
        }));
        // Check using includes (O(n) for each filter item)
        setAppName(appList);
      }
    } catch (error) {
      console.error("Error fetching brand data:", error); // Log any errors for easier debugging
    }
  };
  const handleAddAppsSearch = (query: string) => {
    getBrandsData(query);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, setFieldError }: FormikHelpers<any>
  ) => {
    if (inviteUserInBulkModal.data?.length === 0) {
      Toasts.error("Please select at least one person from the table");
      return;
    }
    const payload = {
      userIds: inviteUserInBulkModal.data,
      appName: values.appName.value,
    };
    console.log("payload", payload);
    try {
      const res = await apiLibrary.userProfile.bulkInvitation(payload);
      Toasts.success(res.message);

      handleClose();
      dispatch(usersStatusAction("all"));
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error.message;
      Toasts.error(errorMsg);
    } finally {
    }
  };

  useEffect(() => {
    getBrandsData();
  }, []);
  return (
    <Modal
      open={inviteUserInBulkModal?.isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      disableAutoFocus={true}
      aria-describedby="modal-modal-description"
      className="border-none"
    >
      <Box sx={style} className="dark:bg-secondaryLight">
        <Formik
          initialValues={initialValues}
          validationSchema={createPasswordModalValidationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            resetForm,
            setFieldValue,
            isSubmitting,
            setFieldError,
          }) => (
            <Form>
              <div className="flex flex-col justify-start items-start w-[600px] rounded-lg">
                <div
                  className="relative flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4 p-6 rounded-lg dark:bg-secondaryLight bg-bgWhite"
                  style={{
                    boxShadow:
                      "0px 2px 8px 0 rgba(2,13,36,0.1), 0px 2px 24px 0 rgba(2,13,36,0.08)",
                  }}
                >
                  <div className="flex  justify-between items-start self-stretch flex-grow-0 flex-shrink-0 py-0.5">
                    <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
                      <p className="flex-grow text-xl font-semibold text-left text-textMid dark:text-textMain">
                        Bulk Invitation Request
                      </p>
                    </div>
                    <button onClick={handleClose} type="button">
                      <XCloseIcon width={24} height={24} viewBox="0 0 24 24" />
                    </button>
                  </div>
                  <div className="flex justify-start flex-col items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-2 pb-1.5">
                    <div className="ml-[2px] mt-1 w-full px-2">
                      <p className="text-textMid dark:text-textMain py-1">
                        Select an App
                      </p>
                      <MultiSelect
                        inputValue={searchString}
                        onInputChange={(value: string) => {
                          setSearchString(value);
                          handleAddAppsSearch(value);
                        }}
                        className={
                          "border-lineDark border rounded-md capitalize"
                        }
                        options={appName}
                        defaultValue={{ value: "", label: "" }}
                        isMulti={false}
                        placeholder="Select A Brand"
                        closeOnSelect={true}
                        value={values?.appName?.value ? values.appName : null}
                        onChange={(option: any) => {
                          setFieldValue("appName", option);
                        }}
                      />
                      {errors?.appName && (
                        <p className="text-accent_1Dark text-xs">
                          App name is required
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center self-stretch justify-end flex-grow-0 flex-shrink-0 gap-2">
                    <Button
                      type="button"
                      text="Cancel"
                      filledColor="primary"
                      outlinedColor="primary"
                      textColor="textWhite"
                      className="px-5 py-2"
                      width="35"
                      height="13"
                      fontStyle="font-semibold"
                      variant="outlined"
                      onClick={handleClose}
                    />

                    <Button
                      disabled={isLoading}
                      type="submit"
                      text="Submit"
                      filledColor="primary"
                      outlinedColor="primary"
                      textColor="textWhite"
                      className="px-5 py-2"
                      width="35"
                      height="13"
                      fontStyle="font-semibold"
                      variant="filled"
                      onClick={() => {
                        handleSubmit;
                      }}
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};
